export enum AspectRatio {
    WIDESCREEN = 'widescreen',
    FULLSCREEN = 'fullscreen'
}